// extracted by mini-css-extract-plugin
export var columnList = "_al-0";